<template>
  <el-dialog title="意见反馈" :visible.sync="dialogVisible" class="opinionaire" width="600px">
    <div>
      <h4>问题类型</h4>

      <template>
        <el-radio v-model="type" label="1">网站使用问题</el-radio>
        <el-radio v-model="type" label="2">课程内容问题</el-radio>
        <el-radio v-model="type" label="3">意见及反馈</el-radio>
      </template>
    </div>

    <div>
      <h4>反馈内容</h4>
      <v-md-editor v-model="description" mode="preview" />
    </div>

    <div class="submit-button">
      <el-button type="primary">提交反馈</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      type: '1',
      description: '请填写你遇到的问题或对我们的意见和建议，我们会认真听取和改进。如果问题合理，我们会给予相应的奖励，请填写不超过 300 字的内容',
      dialogVisible: false
    }
  },
  props: {
    flag: null
  },
  watch: {
    flag () {
      this.dialogVisible = true
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.submit-button {
  margin-left: 450px;
  margin-top: 10px;
}
/* 携带的样式 markdown-body */
/deep/ .vuepress-markdown-body code {
  padding: 2px 5px;
  /* font-size: 1.3rem; */
  color: #c7254e;
  border-radius: 2px;
  background: #f8f8f8;
}
/deep/ .vuepress-markdown-body {
  padding: 8px 0 !important;
  color: #24292e !important;
}
.opinionaire /deep/ .el-dialog__body {
  padding-top: 0;
}
</style>
